import React, { ReactElement } from 'react';
import ShadowBlock from '../shadow-block/shadow-block.component';
import DeleteIconButton from '../delete-icon-button/delete-icon-button.component';
import FormatService from '../../services/format-service';
import useStylesImageControlsBlock from './image-controls-block.styles';

const ImageControlsBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isFloating,
    isTransparent,
    withDelete,
    className,
    onDeleteClick,
  } = props;

  const { classes } = useStylesImageControlsBlock();

  const isEnabled: boolean = !!onDeleteClick;

  const floatingClassName: string | undefined = isFloating ? classes.imageControlsBlockFloating : undefined;
  const transparentClassName: string | undefined = isTransparent ? classes.imageControlsBlockTransparent : undefined;

  return (
    <div
      className={FormatService.formatClassNames(
        classes.imageControlsBlock, floatingClassName, transparentClassName, className,
      )}
    >
      {
        withDelete && isEnabled && (
          <ShadowBlock>
            <DeleteIconButton className={classes.deleteImageButton} onClick={onDeleteClick} />
          </ShadowBlock>
        )
      }
    </div>
  );
});

export default ImageControlsBlock;
